import { translate } from "../../util/translate"

export const missionHeaders = [
  {
    text: translate['mission.label.name'],
    value: 'name',
    width: 350,
  },
  {
    text: translate['mission.label.startDate'],
    value: 'start_date',
    width: 150,
  },
  {
    text: translate['mission.label.endDate'],
    value: 'end_date',
    width: 150,
  },
  {
    text: translate['mission.label.price'],
    value: 'price',
    width: 120,
    align: 'right',
  },
  {
    text: translate['mission.label.active'],
    value: 'active',
    width: 80,
    align: 'center',
  },
  {
    text: translate['mission.label.actions'],
    value: 'actions',
    align: 'center',
    width: 80,
  },
]

export const missionProgressHeaders = [
  {
    text: translate['mission.label.hostName'],
    value: 'host_email',
    width: '320',
  },
  {
    text: translate['mission.label.missionProgress'],
    value: 'services_done',
    width: '180',
  },
  {
    text: translate['mission.label.serviceCount'],
    value: 'total_mission_services',
    width: '130',
    align: 'center',
  },
  {
    text: translate['mission.label.paymentId'],
    value: 'payment_id',
    width: '150',
  },
  {
    text: translate['mission.label.endDate'],
    value: 'ending_date',
    width: '180',
  },
  {
    text: translate['mission.label.actions'],
    value: 'actions',
    align: 'center',
    width: '70',
  },
]
